module.exports = __webpack_public_path__ + "static/media/olderadult.720b8c5a.svg";